// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_gh-0";
export var animationContainer = "_gh-1";
export var modalContent = "_gh-2";
export var orderName = "_gh-3";
export var refundOption = "_gh-4";
export var refundOptionsContainer = "_gh-5";